import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

interface Props extends StyleProps {
  videoId: string;
  title?: string;
}

export const YouTubeEmbededVideo: FC<Props> = ({ className, style = {}, videoId, title = 'YouTube video player' }) => {
  return (
    <div className={mc('relative h-0 w-full', className)} style={{ paddingTop: '56.25%', ...style }}>
      <iframe
        className="absolute top-0 left-0 w-full h-full border-none"
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      />
    </div>
  );
};

export type YouTubeEmbededVideoProps = Props;
export default YouTubeEmbededVideo;
